import {useEffect, useState} from "react"
import {Copy, Eye, EyeOff, Grid} from 'react-feather'
import UseCopyToClipboard from "../../hooks/UseCopyToClipboard";


const Input = (options) => {
    const [passwordVisible, setPasswordVisible] = useState(false)
    const [value, setValue] = useState(options && options.value ? options.value : '');
    const [length, setLength] = useState(options && options.value ? options.value.length : 0);

    const name = options && options.name != undefined ? options.name : '';
    const type = options && options.type != undefined ? options.type : 'text';
    const disabled = options && options.disabled != undefined ? options.disabled : false
    const className = options && options.className != undefined ? options.className : 'form-control input-sm'
    const placeholder = options && options.placeholder != undefined ? options.placeholder : 'Type something...'


    useEffect(() => {


    }, [value])


    const handleChange = async (event) => {
        let inputVal = event.target.value;

        if (typeof options.onChange == "function") {
            const onChangeValue = options.onChange(event)
            if (onChangeValue != undefined) {
                inputVal = onChangeValue
            }
        }

        setLength(inputVal.length)
        setValue(inputVal);
    }


    const handleBlur = () => {
        if (typeof options.onBlur == "function") {
            options.onBlur(value)
        }
    }


    const handleCopy = () => {
        UseCopyToClipboard(
            options?.prepend ? options.prepend + value : value
        )
    }


    const InputOptions = {
        name: name,
        value: options?.prepend ? options.prepend + value : value,
        autoComplete: `new-${name}`,
        disabled: disabled,
        onBlur: handleBlur,
        onChange: handleChange,
        placeholder: placeholder,
        maxLength: options.maxLength,
        type: passwordVisible ? "text" : type,
        className: options.canCopy ? className + ' canCopy ' : className,
        onKeyPress: (event) => {event.key === 'Enter' && event.preventDefault()}
    }


    if(type == 'datetime-local'){
        InputOptions.min = options.min ? options.min : new Date().toISOString().slice(0, -8)
    }


    return (
        <div className="Input input-container">
            <input {...InputOptions}/>

            {options.counter && <span className="counter">{length}</span>}
            {options.canCopy && <span className="copy" onClick={handleCopy}><Copy/></span>}
            {options.suffix && <span className="suffix">{options.suffix}</span>}
            {options.addon && <span className="copy" data-tip={options.addon.label} onClick={(event) => {
                options.addon.onClick(event)
            }}><Grid/></span>}
            {type === "password" && <span className="copy" data-tip={"View password"} onClick={(event) => {
                setPasswordVisible(!passwordVisible)
            }}>{passwordVisible ? <EyeOff /> : <Eye/>}</span>}


        </div>
    )
}


export default Input;